import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCodeBooksQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetCodeBooksQuery = { __typename?: 'query_root', code_books: Array<{ __typename?: 'code_books', id: any, abbreviation: string, edition_year?: number | null, title: string, publisher?: string | null, book_type: string, source_file_name?: string | null, source_file_url?: string | null, page_count?: number | null, section_count: number }> };


export const GetCodeBooksDocument = gql`
    query getCodeBooks($jurisdictionId: uuid!) {
  code_books(
    where: {active: {_eq: true}, _or: [{jurisdiction_id: {_is_null: true}}, {jurisdiction_id: {_eq: $jurisdictionId}}]}
    order_by: [{abbreviation: asc}, {edition_year: desc}]
  ) {
    id
    abbreviation
    edition_year
    title
    publisher
    book_type
    source_file_name
    source_file_url
    page_count
    section_count
  }
}
    `;

/**
 * __useGetCodeBooksQuery__
 *
 * To run a query within a React component, call `useGetCodeBooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCodeBooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCodeBooksQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetCodeBooksQuery(baseOptions: Apollo.QueryHookOptions<GetCodeBooksQuery, GetCodeBooksQueryVariables> & ({ variables: GetCodeBooksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCodeBooksQuery, GetCodeBooksQueryVariables>(GetCodeBooksDocument, options);
      }
export function useGetCodeBooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCodeBooksQuery, GetCodeBooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCodeBooksQuery, GetCodeBooksQueryVariables>(GetCodeBooksDocument, options);
        }
export function useGetCodeBooksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCodeBooksQuery, GetCodeBooksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCodeBooksQuery, GetCodeBooksQueryVariables>(GetCodeBooksDocument, options);
        }
export type GetCodeBooksQueryHookResult = ReturnType<typeof useGetCodeBooksQuery>;
export type GetCodeBooksLazyQueryHookResult = ReturnType<typeof useGetCodeBooksLazyQuery>;
export type GetCodeBooksSuspenseQueryHookResult = ReturnType<typeof useGetCodeBooksSuspenseQuery>;
export type GetCodeBooksQueryResult = Apollo.QueryResult<GetCodeBooksQuery, GetCodeBooksQueryVariables>;